/* eslint-disable promise/catch-or-return, promise/always-return */
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag.js'
import { createTracker } from '@nrk/dh-snowplow'
import { EventSchema, ViewportEventKind } from '@nrk/snowplow-web'
import Animasjonsscroll from './components/animasjonsscroll.js'
import ProsentvisVideo from './components/media/prosentvis-video.js'
import ProsentvisBilde from './components/media/prosentvis-bilde.ts'
import ProsentvisOvergang from './components/media/prosentvis-overgang.js'
import './lib/scroll-timeline.js'

import './components/animasjonsscroll.module.css'
import './client.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends HTMLElement {
  name = tag
  #entryObserver
  #exitObserver
  #tracker

  connectedCallback() {
    this.#defineCustomElements()
    this.#createTracker()
    this.#startViewportLogger()
  }

  disconnectedCallback() {
    this.#stopViewportLogger()
  }

  async #defineCustomElements() {
    safeDefine('dh-animasjonsscroll', Animasjonsscroll)
    safeDefine('dh-prosentvis-video', ProsentvisVideo)
    safeDefine('dh-prosentvis-bilde', ProsentvisBilde)
    safeDefine('dh-prosentvis-overgang', ProsentvisOvergang)

    if (this.features.lottie && typeof customElements.get('dh-prosentvis-lottie') === 'undefined') {
      const prosentvisLottie = (
        await import(
          './components/media/prosentvis-lottie.js' /* webpackChunkName: "dh-prosentvis-lottie" */
        )
      ).default
      safeDefine('dh-prosentvis-lottie', prosentvisLottie)
    }

    if (this.features.gltf && typeof customElements.get('dh-prosentvis-gltf') === 'undefined') {
      const prosentvisGLTF = (
        await import(
          './components/media/prosentvis-gltf.js' /* webpackChunkName: "dh-prosentvis-gltf" */
        )
      ).default
      safeDefine('dh-prosentvis-gltf', prosentvisGLTF)
    }
  }

  #createTracker() {
    if (process.env.DEV) {
      import('@nrk/dh-snowplow/mock').then(({ mock }) => mock()).catch(console.error)
    }

    this.tracker = createTracker('dh-animasjonsscroll', {
      environment: process.env.ENVIRONMENT,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #startViewportLogger() {
    this.#entryObserver = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) {
        return
      }
      this.#entryObserver.disconnect()
      this.#exitObserver.observe(this)
      this.tracker.trackSelfDescribingEvent({
        schema: EventSchema.ViewportEvent,
        data: {
          kind: ViewportEventKind.Entry,
        },
      })
    }, {})

    this.#exitObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) {
          return
        }
        this.#exitObserver.disconnect()
        this.tracker.trackSelfDescribingEvent({
          schema: EventSchema.ViewportEvent,
          data: {
            kind: ViewportEventKind.Exit,
          },
        })
      },
      { threshold: [1], rootMargin: '3000px 0px -100% 0px' },
    )

    this.#entryObserver.observe(this)
  }

  #stopViewportLogger() {
    this.#entryObserver?.disconnect()
    this.#exitObserver?.disconnect()
  }

  get features() {
    return JSON.parse(this.getAttribute('features') || '{}')
  }
}

safeDefine(tag, AppElement)
